var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLsqAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0625 9.89999C14.0625 10.2106 13.8107 10.4625 13.5 10.4625H4.5C4.18934 10.4625 3.9375 10.2106 3.9375 9.89999C3.9375 9.58933 4.18934 9.33749 4.5 9.33749H13.5C13.8107 9.33749 14.0625 9.58933 14.0625 9.89999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99998 14.9629C8.68932 14.9629 8.43748 14.711 8.43748 14.4004L8.43748 5.40039C8.43748 5.08973 8.68932 4.83789 8.99998 4.83789C9.31064 4.83789 9.56248 5.08973 9.56248 5.40039L9.56248 14.4004C9.56248 14.711 9.31064 14.9629 8.99998 14.9629Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsqAdd);
export default __webpack_public_path__ + "static/media/lsq_add.fde1c637fd34612cca2aef9fd7a2e52f.svg";
export { ForwardRef as ReactComponent };